<template>
    <a-modal :title="props.detailData.platform_name + ` 备用金变更`" :width="1000" :open="true" @cancel="cancel">
        <template #footer>
            <a-button @click="cancel">取消</a-button>
            <a-popconfirm title="是否确定？" @confirm="onFormSubmit">
                <a-button type="primary" :loading="state.submitLoading">确定</a-button>
            </a-popconfirm>
        </template>
        <a-skeleton :loading="state.loading" active :paragraph="{ rows: 10 }">
            <a-form ref="ruleForm" :model="formData" v-bind="formLayout">
                <a-form-item label="类型" name="type" required>
                    <a-radio-group v-model:value="formData.type" button-style="solid">
                        <a-radio :value="1">收入</a-radio>
                        <a-radio :value="2">支出</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="关联行为" name="source_type">
                    <a-select v-model:value="formData.source_type" placeholder="请选择">
                        <a-select-option :value="1">入账备用金</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="流水发生时间" required>
                    <a-date-picker v-model:value="formData.amount_time" :format="format" show-time
                        value-format="YYYY-MM-DD HH:mm:ss" />
                </a-form-item>
                <a-form-item label="金额" name="amount" required>
                    <a-input v-model:value="formData.amount" placeholder="请输入金额" prefix="￥" suffix="RMB"></a-input>
                </a-form-item>
                <a-form-item label="附件" name="attachment">
                    <Upload :upload_path="`public/uploads/manage/财务管理/备用金/${dayjs().format('YYYYMM')}/`"
                        :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png']" uploadType="text"
                        v-model:value="formData.attachment" :limitation="99" uploadText="上传附件">
                    </Upload>
                </a-form-item>
                <a-form-item label="备注">
                    <a-textarea v-model:value="formData.remark" :rows="4" placeholder="请输入备注"></a-textarea>
                </a-form-item>
            </a-form>
        </a-skeleton>
    </a-modal>
</template>

<script lang="ts" setup>
import { message, Modal } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { reactive, onMounted, ref } from 'vue'
import Upload from '@/components/base/Upload.vue'
import dayjs from 'dayjs'
const format = 'YYYY-MM-DD HH:mm:ss'
const formLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 }
    }
}
const ruleForm = ref()
const emit = defineEmits(['cancel', 'ok'])
const props = defineProps({
    detailData: {
        type: Object,
        default: () => { }
    }
})
interface IState {
    loading: boolean
    submitLoading: boolean
}
const state = reactive<IState>({
    loading: false,
    submitLoading: false,
})
interface IformData {
    type: number
    source_type: number
    amount_time: any
    amount: number | null
    attachment: any[]
    remark: string
}
const formData = reactive<IformData>({
    type: 1,
    source_type: 1,
    amount_time: null,
    amount: null,
    attachment: [],
    remark: '',
})
onMounted(() => {
    formData.amount_time = dayjs().format(format)
})

// 提交
const onFormSubmit = () => {
    ruleForm.value
        .validate()
        .then(() => {
            state.loading = true
            let postData = Object.assign({ petty_cash_id: props.detailData.id }, formData)
            let requeryParam = {
                url: '/admin/v1/pettycash/logadd',
                method: 'post',
                data: postData
            }
            baseService(requeryParam)
                .then((res: any) => {
                    state.loading = false
                    message.success(res.msg)
                    emit('ok')
                })
                .catch((res) => {
                    state.loading = false
                    if (res.msg) {
                        message.error(res.msg)
                    } else {
                        message.error('操作失败')
                    }
                })
        })
        .catch(() => { })
}
const cancel = () => {
    emit('cancel')
}
</script>

<style lang="less" scoped></style>
